import React, { useState } from 'react';
import { Card, Row, Col, Accordion } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProjectBody from './ProjectBody';
import ElsterUploadSection from './ElsterUploadSection';
import AccordionCustomToggle from '@rd-web-markets/shared/dist/util/AccordionCustomToggle';
import GroupOverviewNotesList from './ProjectOverviewNotes/GroupOverviewNotesList';
import { createTimezonedDate } from '@rd-web-markets/shared/dist/util/date';
import FinancialYearModal from '@rd-web-markets/market/dist/company/add_financial_year/FinancialYearModal';
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
const ProjectOverview = _ref => {
  let {
    claimProjectReports,
    financialYear,
    elster,
    setElster,
    fetchAllProjetcs,
    fetchElster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [showFinancialYearModal, setShowFinancialYearModal] = useState(false);
  const [open, setOpen] = useState(false);
  const headings = /*#__PURE__*/React.createElement(Accordion, {
    defaultActiveKey: 0,
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Accordion.Button, {
    onClick: () => {},
    as: Card.Header,
    eventKey: "0"
  }, /*#__PURE__*/React.createElement(Row, {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, t('project')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('elster_project_ duration_start')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('elster_project_duration_end')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('application_number')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('timesheet')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('staff_cost')), /*#__PURE__*/React.createElement(Col, {
    md: 2
  }, t('contract_research_invoices_and_offers')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }, t('project_documentation')), /*#__PURE__*/React.createElement(Col, {
    md: 1
  }))), /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement("div", null)));
  const body = claimProjectReports.map((project, index) => {
    return /*#__PURE__*/React.createElement(ProjectBody, {
      project: project,
      key: project.id,
      fetchAllProjetcs: fetchAllProjetcs
    });
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, showFinancialYearModal && /*#__PURE__*/React.createElement(FinancialYearModal, {
    show: showFinancialYearModal,
    onHide: () => setShowFinancialYearModal(false),
    companyId: elster.company_id,
    elster: elster,
    startDate: elster.start_date,
    endDate: elster.end_date,
    warningMessage: t('date_change_could_result_in_data_loss_of_removed_projects'),
    showPreviousElsterDates: true,
    afterSubmitActions: async () => {
      await fetchElster();
      await fetchAllProjetcs();
    }
  }), /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Accordion, {
    defaultActiveKey: "0"
  }, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: 8
  }, /*#__PURE__*/React.createElement("div", {
    onClick: () => setOpen(!open)
  }, /*#__PURE__*/React.createElement(AccordionCustomToggle, {
    eventKey: "0",
    open: open
  }, t('document_upload')))), /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("span", {
    style: {
      marginRight: '5px'
    }
  }, t('time_period'), ": ", createTimezonedDate(elster.start_date, true).toCustomLocaleDateString(), " To ", createTimezonedDate(elster.end_date, true).toCustomLocaleDateString()), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setShowFinancialYearModal(true),
    className: "ms-auto me-3"
  }, t('change_date')))), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Accordion.Collapse, {
    eventKey: "0"
  }, /*#__PURE__*/React.createElement(ElsterUploadSection, {
    elster: elster,
    setElster: setElster
  })))), headings, body, /*#__PURE__*/React.createElement(GroupOverviewNotesList, {
    elster: elster,
    setElster: setElster
  }))));
};
export default ProjectOverview;